import {
  tooltipPlacement,
  TooltipTrigger,
} from "@visiblethread/react-components";
import clsx from "clsx";
import { FILE_SOURCES } from "layout/documentUploader/constants";
import { bool, elementType, func, string } from "prop-types";
import { Fragment } from "react";

const NavigationItem = ({
  source,
  active,
  label,
  Icon,
  disabled,
  disabledLabel,
  onClick,
}) => {
  const handleClick = () => {
    onClick(source);
  };

  return (
    <Fragment>
      <li
        className={clsx("choose_files_modal__body__navigation__item", {
          disabled,
        })}
      >
        <TooltipTrigger
          content={disabledLabel}
          placement={tooltipPlacement.right}
          isEnabled={disabled}
          tooltipStyle={{ zIndex: 105001 }}
        >
          <button
            className={clsx(
              "choose_files_modal__body__navigation__item__button",
              { active, disabled }
            )}
            data-testid={`${label}-navigation-item`}
            disabled={disabled}
            onClick={handleClick}
          >
            <Icon />
          </button>
        </TooltipTrigger>
        <span className="choose_files_modal__body__navigation__item__label">
          {label}
        </span>
      </li>

      {source === FILE_SOURCES.COLLECTIONS && (
        <div className="choose_files_modal__body__navigation__item__divider" />
      )}
    </Fragment>
  );
};

NavigationItem.propTypes = {
  source: string.isRequired,
  active: bool.isRequired,
  label: string.isRequired,
  Icon: elementType.isRequired,
  disabled: bool,
  disabledLabel: string,
  onClick: func.isRequired,
};

export default NavigationItem;
